import React, { useEffect, useLayoutEffect, useState } from "react";
import HeadingComponent from "components/headingComponent";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import AsyncSelect from "react-select/async";
import ButtonLabels from "helper/constant/buttonLabels";
import CommonHeadings from "helper/constant/headings";
import BottomButtons from "components/buttons/bottomButtons";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  addDoc,
  and,
  collection,
  doc,
  getDoc,
  getDocs,
  or,
  query,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import TableName from "helper/tableName/tableName";
import RoutingPaths from "helper/routingPath";
import ToastMessages from "helper/toastMessages";
import { useLocation, useNavigate } from "react-router-dom";
import Dateformat from "helper/constant/timeFormat";
import moment from "moment";
import ErrorMessages from "helper/errorMessages";

function AddStudentPerformance() {
  const [isSubmitted, setIsSubmitted] = useState(false); // when we submit the form, it will check the error
  const [studentHeading, setStudentsHeading] = useState(
    CommonHeadings.studentMarksAddHeading
  );
  const [testDate, setTestDate] = useState(null);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [buttonLabel, setButtonLabel] = useState(ButtonLabels.saveLabel);
  const [studentsID, setStudentsID] = useState();
  const navigate = useNavigate();
  const location = useLocation();

  const [performanceData, setPerformanceData] = useState({
    student_firebase_id: null,
    student_type: null,
    student_name: "",
    admission_number: "",
    test_date: null,
    test_date_timestamp: null,
    speaking_marks: "",
    writing_marks: "",
    listening_marks: "",
    reading_marks: "",
    overall_marks: "",
  });

  const [errors, setErrors] = useState({
    student_firebase_id: null,
    student_type: null,
    student_name: "",
    admission_number: "",
    test_date: "",
  });

  // MARK: use effect method
  useEffect(() => {
    if (location.state) {
      setEditStudentsPerformanceUI();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // use layout method
  useLayoutEffect(() => {
    document.title = location.state
      ? CommonHeadings.studentMarksEditHeading
      : CommonHeadings.studentMarksAddHeading;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //   when we enter any value that's set in the setDemoStudents() and change the input afer submitting like blank all the inputs
  const inputChange = (e) => {
    var { name, value } = e.target;

    if (name === "test_date") {
      value = moment(value).format(Dateformat.YYYYMMDD);
    }

    setPerformanceData({
      ...performanceData,
      [name]: value,
    });
  };

  const studentsTypeSelect = (e) => {
    const name = "student_type";

    setPerformanceData({
      ...performanceData,
      [name]: e,
    });
  };

  const studentsSelect = (e) => {
    const name = "student_firebase_id";

    setPerformanceData({
      ...performanceData,
      [name]: e,
    });

    if (e === null) {
      return;
    }
    setPerformanceData((prevState) => ({
      ...prevState,
      student_name: e.name,
      admission_number: e.admission_no,
    }));
  };

  const validateForm = (data) => {
    const errors = {};
    if (!data.student_name) {
      errors.student_name = ErrorMessages.studentName;
    }
    if (!data.admission_number) {
      errors.admission_number = ErrorMessages.admissionNumber;
    }
    if (!data.test_date) {
      errors.test_date = ErrorMessages.testDate;
    }
    if (!data.student_type) {
      errors.student_type = ErrorMessages.studentType;
    }
    if (data.student_type === "existing_student") {
      if (!data.student_firebase_id) {
        errors.student_firebase_id = ErrorMessages.studentId;
      }
    }

    return errors;
  };

  // MARK: edit data function
  async function setEditStudentsPerformanceUI() {
    const studentTypeObject = await fetchStudentTypeApi();

    const testDate = stringToDate(location.state.test_date);
    setTestDate(testDate);

    var regularStudentObject;
    if (studentTypeObject.type === "existing_student") {
      regularStudentObject = await fetchRegularStudentApi();
    } else {
      regularStudentObject = null;
    }

    setPerformanceData((prevState) => ({
      ...prevState,
      student_type: studentTypeObject,
      student_firebase_id: regularStudentObject,
      student_name: location.state.student_name,
      admission_number: location.state.admission_number,
      test_date: location.state.test_date,
      speaking_marks: location.state.speaking_marks,
      writing_marks: location.state.writing_marks,
      listening_marks: location.state.listening_marks,
      reading_marks: location.state.reading_marks,
      overall_marks: location.state.overall_marks,
    }));
    setStudentsHeading(CommonHeadings.studentMarksEditHeading);
    setButtonLabel(ButtonLabels.updateLabel);
    setStudentsID(location.state.id);
  }

  // MARK: payload function
  function payload() {
    const createdAt = Timestamp.fromDate(new Date()).toMillis();

    const object = {
      ...performanceData,
      created_at: createdAt,
      updated_at: null,
    };

    const dateOnly = Timestamp.fromDate(new Date(object.test_date)).toMillis();
    object.test_date_timestamp = dateOnly;
    object.student_name = performanceData.student_name.toLowerCase();

    return object;
  }

    // MARK: string to date
    const stringToDate = (props) => {
      return moment(props, Dateformat.YYYYMMDD).toDate();
    };

  // MARK: reset values function
  function ResetValues() {
    setPerformanceData({
      student_firebase_id: null,
      student_type: null,
      student_name: "",
      admission_number: "",
      test_date: "",
      test_date_timestamp: "",
      speaking_marks: "",
      writing_marks: "",
      listening_marks: "",
      reading_marks: "",
      overall_marks: "",
    });
  }

  // MARK: API
  //write API
  async function writeStudentsPerformancesApi(edit) {
    const writePayload = payload();
    writePayload.student_type = performanceData.student_type.type;
    if (performanceData.student_firebase_id) {
      writePayload.student_firebase_id =
        performanceData.student_firebase_id.firebase_id;
    }

    try {
      await addDoc(collection(dbFirestore, TableName.studentPerformance), {
        ...writePayload,
      });

      if (edit) {
        toast.success(ToastMessages.performanceAdd);
        setTimeout(() => {
          setLoading2(false);
          // when user press on save + next
          navigate(RoutingPaths.addStudentPerformance);
          ResetValues();
        }, 600);
      } else {
        toast.success(ToastMessages.performanceAdd);
        setTimeout(() => {
          setLoading1(false);
          navigate(RoutingPaths.studentPerformanceList);
        }, 600);
      }
    } catch (error) {
      setLoading1(false); // hide
      setLoading2(false);
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // update API
  async function updateStudentsPerformancesApi() {
    const updatedPayload = payload();
    updatedPayload.created_at = location.state.created_at;
    updatedPayload.updated_at = Timestamp.fromDate(new Date()).toMillis();
    updatedPayload.student_type = performanceData.student_type.type;
    if (performanceData.student_firebase_id) {
      updatedPayload.student_firebase_id =
        location.state.student_firebase_id;

    }
    try {
      await updateDoc(
        doc(dbFirestore, TableName.studentPerformance, studentsID),
        {
          ...updatedPayload,
        }
      );
      toast.success(ToastMessages.performanceUpdated);

      setTimeout(() => {
        setLoading1(false);
        navigate(RoutingPaths.studentPerformanceList);
      }, 600);
    } catch (error) {
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // student type API
  async function fetchStudentTypeApi() {
    let q = query(collection(dbFirestore, TableName.studentsType));

    const querySnapshot = await getDocs(q);

    const studentTypeArray = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
    }));

    var typeObject = studentTypeArray.find(function (studentType) {
      return studentType.type === location.state.student_type;
    });

    return typeObject;
  }

  // regular student API
  async function fetchRegularStudentApi() {
    const docRef = doc(dbFirestore, TableName.students, location.state.student_firebase_id)
    const docSnap = await getDoc(docRef);
    
    return docSnap.exists() ? docSnap.data() : null;
  }

  // MARK: tap on button
  // this function is working when we submit the form by clicking on save button
  const tapOnSave = () => {
    const newErrors = validateForm(performanceData);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading1(true);
      if (location.state) {
        updateStudentsPerformancesApi();
      } else {
        writeStudentsPerformancesApi();
      }
    }
  };

  // this function is working when we submit the form by clicking on save andnext button
  const tapOnSaveNext = () => {
    const newErrors = validateForm(performanceData);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading2(true);
      writeStudentsPerformancesApi(true);
    }
  };

  // MARK: students list fetch from the firebase
  const regularStudentsList = async (searchText) => {
    const searchName = searchText.toLowerCase()
    let q = query(
      collection(dbFirestore, TableName.students), and(
        where('status', '==', 'active'),   
      or(
        // query as-is:
        and(
          where("name", ">=", searchName),
          where("name", "<=", searchName + "\uf8ff")
        ),
        and(
          where(
            "name",
            ">=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1)
          ),
          where(
            "name",
            "<=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1) + "\uf8ff"
          )
        )
      )
    ));
    const querySnapshot = await getDocs(q);
    const s = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      firebase_id: docs.id,
    }));

    return s;
  };

  // students name which show in the dropdown
  function studentsName(e) {
    return e["name"] + " - " + e["admission_no"];
  }

  // MARK: students list fetch from the firebase
  const studentsTypeList = async (searchText) => {
    const searchName = searchText.toLowerCase()

    let q = query(
      collection(dbFirestore, TableName.studentsType),
      or(
        // query as-is:
        and(
          where("type", ">=", searchName),
          where("type", "<=", searchName + "\uf8ff")
        ),
        and(
          where(
            "type",
            ">=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1)
          ),
          where(
            "type",
            "<=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1) + "\uf8ff"
          )
        )
      )
    );
    const querySnapshot = await getDocs(q);
    const s = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
    }));

    return s;
  };

  // students name which show in the dropdown
  function studentsType(e) {
    return e["type"];
  }

  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <HeadingComponent classname="mb-1 mt-3" headingName={studentHeading} />

          <div className="p-fluid">
            <div className="row modules__row mt-4">
              <div className="col-12 col-md-6">
                <label htmlFor="student_type" className="input__valid">
                  Student Type
                </label>
                <AsyncSelect
                  classNamePrefix="batch__dropdown"
                  isClearable
                  cacheOptions
                  loadOptions={studentsTypeList}
                  value={performanceData.student_type}
                  defaultOptions
                  getOptionLabel={(e) => studentsType(e)}
                  getOptionValue={(e) => e["id"]}
                  onChange={studentsTypeSelect}
                />
                {isSubmitted && (
                  <small id="student_type" className="p-error">
                    {errors.student_type}{" "}
                  </small>
                )}
              </div>

              {performanceData.student_type?.type === "existing_student" && (
                <div className="col-12 col-md-6">
                  <label htmlFor="student_firebase_id" className="input__valid">
                    Select Student
                  </label>
                  <AsyncSelect
                    isClearable
                    cacheOptions
                    loadOptions={regularStudentsList}
                    value={performanceData.student_firebase_id}
                    defaultOptions
                    getOptionLabel={(e) => studentsName(e)}
                    getOptionValue={(e) => e}
                    onChange={studentsSelect}
                  />

                  {isSubmitted && (
                    <small id="student_firebase_id" className="p-error">
                      {errors.student_firebase_id}{" "}
                    </small>
                  )}
                </div>
              )}

              <div className="col-12 col-md-6">
                <label htmlFor="student_name" className="input__valid">
                  Student Name
                </label>
                <InputText
                  name="student_name"
                  value={performanceData.student_name}
                  onChange={inputChange}
                  id="student_name"
                  type="text"
                  placeholder="Enter student name"
                />
                {isSubmitted && (
                  <small id="student_name" className="p-error">
                    {errors.student_name}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="admission_number" className="input__valid">
                  Admission Number
                </label>
                <InputText
                  name="admission_number"
                  value={performanceData.admission_number}
                  onChange={inputChange}
                  id="admission_number"
                  type="text"
                  placeholder="Enter admission number"
                />
                {isSubmitted && (
                  <small id="admission_number" className="p-error">
                    {errors.admission_number}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="test_date" className="input__valid">
                  Test Date
                </label>
                <Calendar
                  name="test_date"
                  value={testDate}
                  onChange={inputChange}
                  showIcon
                  showButtonBar
                  placeholder="dd/mm/yyyy"
                  dateFormat="dd/mm/yy"
                />
                {isSubmitted && (
                  <small id="test_date" className="p-error">
                    {errors.test_date}{" "}
                  </small>
                )}
              </div>
            </div>

            <div className="row modules__row">
              <HeadingComponent
                classname="mb-1 mt-4"
                headingName="Marks Detail"
              />

              <div className="col-12 col-md-6">
                <label htmlFor="speaking_marks">Speaking</label>
                <InputText
                  name="speaking_marks"
                  value={performanceData.speaking_marks}
                  onChange={inputChange}
                  id="speaking_marks"
                  type="text"
                  placeholder="Enter marks"
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="writing_marks">Writing</label>
                <InputText
                  name="writing_marks"
                  value={performanceData.writing_marks}
                  onChange={inputChange}
                  id="writing_marks"
                  type="text"
                  placeholder="Enter marks"
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="listening_marks">Listening</label>
                <InputText
                  name="listening_marks"
                  value={performanceData.listening_marks}
                  onChange={inputChange}
                  id="listening_marks"
                  type="text"
                  placeholder="Enter marks"
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="reading_marks">Reading</label>
                <InputText
                  name="reading_marks"
                  value={performanceData.reading_marks}
                  onChange={inputChange}
                  id="reading_marks"
                  type="text"
                  placeholder="Enter marks"
                />
              </div>
              <div className="col-12 col-md-6">
                <label htmlFor="overall_marks">Overall Marks</label>
                <InputText
                  name="overall_marks"
                  value={performanceData.overall_marks}
                  onChange={inputChange}
                  id="overall_marks"
                  type="tel"
                  placeholder="Enter overall detail"
                />
              </div>
            </div>
          </div>
          <BottomButtons
            label={buttonLabel}
            save={tapOnSave}
            loading1={loading1}
            saveNext={tapOnSaveNext}
            loading2={loading2}
          />
          <ToastContainer />
        </div>
      </div>
    </div>
  );
}

export default AddStudentPerformance;
